import { CalendarMonth, Badge, PinDrop } from "./Icons";

import style from "../style/Experience.module.css"

export default function Experience() {
    const exps = [
        {
            startDate: "2022-08-22",
            endDate: "2022-09-10",
            title: "Food & Beverage temp",
            location: "Europa-Park"
        },
        {
            startDate: "2024-09-02",
            endDate: "2025-08-31",
            title: "Voluntary social year",
            location: "St. Josefshaus",
            description: "I completed my FSJ at St Josefshaus, a workshop for disabled people. My main tasks involved looking after people with disabilities. This included providing care (e.g. helping people to go to the toilet), supervising them during breaks, explaining and teaching them new tasks, and instructing them on how to use the internal tablet.\n" +
                "I was also involved in setting up and supervising the mail dispatch area. I taught our clients how to use it, including understanding delivery bills, packing and preparing parcels for dispatch."
        },
        {
            startDate: "2025-09-01",
            endDate: "2028-08-31",
            title: "HEP Apprenticeship",
            location: "St. Josefshaus"
        }
    ]

    exps.sort((a, b) => {
        return new Date(a.startDate) < new Date(b.startDate) ? 1 : -1;
    });

    return (
        <>
            <h1 className={style.sectionTitle}>My experience</h1>

            <div className={style.container}>
                {
                    exps.map((exp) => {
                        const currDate = new Date(),
                            startDate = new Date(exp.startDate),
                            endDate = new Date(exp.endDate);

                        const isActive = startDate < currDate && currDate < endDate,
                            isFuture = startDate > currDate && endDate > currDate;

                        return (
                            <div
                                className={[style.exp, isActive ? style.active : "", isFuture ? style.future : ""].join(" ")}
                                key={exp.title.toLowerCase().replaceAll(" ", "")}
                            >
                                <div className={style.head}>
                                    <div className={style.titleContainer}>
                                        <CalendarMonth className={style.icon} />
                                        <span className={style.date}>
                                            {startDate.toLocaleDateString(["en-US"], {dateStyle: "medium"})} - {endDate.toLocaleDateString(["en-US"], {dateStyle: "medium"})}
                                        </span>
                                    </div>
                                    <div className={style.titleContainer}>
                                        <Badge className={style.icon} />
                                        <h2 className={style.title}>{exp.title}</h2>
                                    </div>
                                    <div className={style.titleContainer}>
                                        <PinDrop className={style.icon} />
                                        <h3 className={style.subTitle}>at <b>{exp.location}</b></h3>
                                    </div>
                                </div>

                                {exp.description && <p className={style.description}>{exp.description}</p>}
                            </div>
                        )
                    })
                }
            </div>
        </>
    )
}